export const enum ImageActionTypes {
  UPLOAD_IMAGE = '[image]UPLOAD_IMAGE',
  UPLOAD_SUCCESS = '[image]UPLOAD_SUCCESS',
  UPLOAD_ERROR = '[image]UPLOAD_ERROR',
  REMOVE_IMAGE = '[image]REMOVE_IMAGE'
}

export interface ImageState {
  readonly loading: boolean;
  readonly errors?: Error;
}



// WEBPACK FOOTER //
// ./src/store/image/types.ts